import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiRoutes } from 'app/routes/app.routes';
import { IFeeStructure, IFeePayment } from 'app/interfaces/fee.interface';
import { Observable } from 'rxjs';
import { HttpService } from '../http/http.service';

@Injectable({
  providedIn: 'root'
})
export class FeeService {
  private baseUrl = ApiRoutes.api.baseUrl;
  private routes = ApiRoutes.api;
  
  constructor(
    private http: HttpClient,
    private httpService: HttpService
  ) { }

  createFeeStructure(payload: IFeeStructure): Observable<any> {
    return this.httpService.makeRequest({
      path: this.routes.fees.addFeeStructure,
      method: 'post',
      options: { body: payload },
      loader: { type: 'button' },
      isAuthRoutes: true
    });
  }

  getFeeStructure(academicYearId: number): Observable<any> {
    return this.httpService.makeRequest({
      path: this.routes.fees.retrieveSingle,
      method: 'get',
      options: { id: +academicYearId },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  makePayment(payload: IFeePayment): Observable<any> {
    return this.httpService.makeRequest({
      path: this.routes.fees.feePayment,
      method: 'post',
      options: { body: payload },
      loader: { type: 'button' },
      isAuthRoutes: true
    });
  }

  getPaymentReceipt(paymentId: number): Observable<any> {
    return this.httpService.makeRequest({
      path: this.routes.fees.feeReceipt,
      method: 'get',
      options: { id: paymentId },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  getLearnerPayments(learnerId: number): Observable<any> {
    return this.httpService.makeRequest({
      path:this.routes.fees.learnerPayments,
      method: 'get',
      options: { id: learnerId },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  getFeeStatistics(): Observable<any> {
    return this.httpService.makeRequest({
      path: this.routes.fees.feeStatistics,
      method: 'get',
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }
} 